import { createApiClient, createTeamsApi, type TeamsApi } from '@teamofone/api-client'
import { currentApiHeaders, currentDevIdentity, currentJwtAsync } from './slackClient'
import { dispatchUnauthorized } from './auth/unauthorized'

export type {
  TeamsApi,
  BackendTeam,
  CreateTeamInput,
  PatchTeamInput,
  PullSummary,
  TeamMember,
  TeamMemberRole,
  AddMemberInput,
  PatchMemberInput,
  WorkloadsResponse,
  ServiceHealth,
  WorkerHealth,
  WorkloadStatus,
  FrontendApp,
  PrefillSource,
  SubteamCatalogRow,
  SubteamCatalogResponse,
  SubteamPreview,
} from '@teamofone/api-client'
export { toSubteamPreview } from '@teamofone/api-client'
export { currentDevIdentity }

const baseUrl =
  (import.meta.env.VITE_TEAMOFONE_API_URL as string | undefined) ??
  'http://localhost:6055/teamofone'

const client = createApiClient({
  baseUrl,
  getToken: currentJwtAsync,
  getExtraHeaders: currentApiHeaders,
  onUnauthorized: dispatchUnauthorized,
})

export const teamsApi: TeamsApi = createTeamsApi(client)
